"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebook = void 0;
var types_1 = require("../types");
exports.facebook = {
    name: 'facebook',
    matches: [
        {
            match: '(https?://)?(www.)?facebook.com/({PROFILE_ID})/?', group: 3, type: types_1.TYPE_DESKTOP,
            pattern: 'https://facebook.com/{PROFILE_ID}'
        },
        {
            match: '(https?://)?m.facebook.com/({PROFILE_ID})/?', group: 2, type: types_1.TYPE_MOBILE,
            pattern: 'https://m.facebook.com/{PROFILE_ID}'
        },
        { match: '({PROFILE_ID})', group: 1 },
    ]
};
//# sourceMappingURL=facebook.js.map